import { render, staticRenderFns } from "./ZlifePetAplicarDiagnostico.vue?vue&type=template&id=893bb8b0"
import script from "./ZlifePetAplicarDiagnostico.vue?vue&type=script&lang=js"
export * from "./ZlifePetAplicarDiagnostico.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports